import React from "react";
import PropTypes from "prop-types";
import LoadFinishedGeneral from "../../../LoadFinishedGeneral";

import styles from "./LoadOrderFinished.module.scss";
import i18n from "i18n";

export const LoadOrderFinished = ({
  orderNumber,
  boldButtonFunc,
  downloadVoucher,
  buttonLink = "/admin/orders/request",
}) => {
  return (
    <LoadFinishedGeneral
      title={i18n.t("order.was.successfully.created")}
      boldButtonLabel={i18n.t("create.another.order")}
      boldButtonFunc={boldButtonFunc}
      buttonLabel={i18n.t("see.list.orders")}
      // boldButtonLink={"/admin/orders/request/load"}
      buttonLink={buttonLink}
    >
      <div className={styles["load-order-finished-container"]}>
        <div className={styles["load-order-finished-number-label"]}>{i18n.t("order.number")}</div>
        <div className={styles["load-order-finished-number"]}>{orderNumber}</div>
        <div
          className={styles["load-order-finished-download-wrapper"]}
          onClick={downloadVoucher}
        >
          <div className={styles["laod-order-finished-icon"]}>
            <i className="icon-iconos_descargar" />
          </div>
          <div className={styles["load-order-finished-download-label"]}>
            {i18n.t("download.receipt")}
          </div>
        </div>
      </div>
    </LoadFinishedGeneral>
  );
};

export default LoadOrderFinished;
